import { getQFromQuery } from '../../utils'
import { ClusteringKMeansSettingsQueryParams } from '../types'

export const generateQuery = ({ geomField, clusters, baseQuery, atLocation }: ClusteringKMeansSettingsQueryParams) => {
  const lastQuery = getQFromQuery(baseQuery) || 1
  const clusteringQquery = `\tWITH clustering AS (
\t\tSELECT
\t\t\t${atLocation}.ST_CLUSTERKMEANS(ARRAY_AGG(${geomField}), ${clusters}) AS result
\t\tFROM
\t\t\t__q${lastQuery}
\t\tWHERE
\t\t\t${geomField} IS NOT NULL
\t)
\tSELECT
\t\tCAST(result.cluster AS string) AS cluster,
\t\tresult.geom AS geom
\tFROM
\t\tclustering, UNNEST(result) AS result`
  const query = `${baseQuery},
__q${lastQuery + 1} AS (
${clusteringQquery}
)
SELECT * FROM __q${lastQuery + 1}`
  return query
}
